import { Color as TiptapColor } from '@tiptap/extension-color'
import { ColorActionButton } from '@/tiptap/extensions/components/ActionButton'

// JS equivalent of the TS extension wrapper
export default TiptapColor.extend({
  addOptions() {
    return {
      ...(this.parent?.() || {}),
      button: ({ editor, t }) => ({
        component: ColorActionButton,
        componentProps: { editor, t },
      }),
    }
  },
})
